/*
 * @Author: cn1994
 * @Date: 2023-09-14 16:09:44
 * @LastEditors: cn1994
 * @LastEditTime: 2024-03-03 15:25:00
 * @Description: file content
 */
const routes = [
  {
    path: '/liveDetail',
    name: 'liveDetail',
    meta: {
      title: '直播中心',
      volcengine: true,
    },
    component: () => import('../pages/live/indexPage.vue'),
  },
  {
    path: '/liveRecords',
    name: 'liveRecord',
    component: () => import('../pages/iframe/index.vue'),
    // component: () => import('../pages/live/records.vue'),
  },
  {
    path: '/livePayDetail',
    name: 'livePayDetail',
    component: () => import('../pages/iframe/index.vue'),
    // component: () => import('../pages/live/payDetail.vue'),
  },
  {
    path: '/livePay',
    name: 'livePay',
    component: () => import('../pages/iframe/index.vue'),
    // component: () => import('../pages/live/pay.vue'),
  },
]
export default routes